import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await login(email, password); nav("/admin"); }
    catch (e2) { setErr(e2.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-ink px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-brand-magenta">Jadoo Ki Jhappy</p>
        <h1 className="mt-2 font-heading text-3xl font-semibold text-brand-ink">Admin Sign In</h1>
        {err && <p data-testid="login-error" className="mt-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">{err}</p>}
        <label className="mt-6 block text-sm font-medium text-brand-ink/70">Email</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 w-full rounded-lg border border-brand-line px-4 py-3 outline-none focus:border-brand-magenta" />
        <label className="mt-4 block text-sm font-medium text-brand-ink/70">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 w-full rounded-lg border border-brand-line px-4 py-3 outline-none focus:border-brand-magenta" />
        <button data-testid="login-submit" disabled={busy} className="mt-6 w-full rounded-full bg-brand-magenta py-3 font-semibold text-white transition-transform hover:scale-[1.02] disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
